// extracted by mini-css-extract-plugin
module.exports = {"split":"Dashboard_split__2Kpd9"};